import { init, isInitialized } from '@fullstory/browser';

import { getUser } from '@platform/core/auth';

import { env } from '@packages/utils/env';

export const FULLSTORY_INTERNAL_ORG_ID = 'o-20FZND-na1';
export const FULLSTORY_EXTERNAL_ORG_ID = 'o-20D05A-na1';

const awEmailRegex = /@arcticwolf\.(com|net)$/;

export const initializeFullStory = async () => {
  if (env.MODE !== 'production' || isInitialized()) {
    return;
  }

  const user = await getUser();

  if (!user?.email) {
    return;
  }

  const orgId = awEmailRegex.test(user.email)
    ? FULLSTORY_INTERNAL_ORG_ID
    : FULLSTORY_EXTERNAL_ORG_ID;

  init({ orgId });
};
